import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';


export default function AcquistoImmobiliare({
    setPrezzodiacquisto, 
    setAgevolazioniPrimaCasa, 
    setRichiestaMutuo, 
    setInfoAggiuntive,
    setRenditaCatastale, 
    setVenditore}) {

	return (
		<>
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' for="from_name">Prezzo di acquisto</label>
                    <input type="number" placeholder="100000" name="prezzo_di_acquisto" id="prezzo_di_acquisto" onChange={e => setPrezzodiacquisto(e.target.value)} />
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Rendita catastale</label>
                    <input type="number" placeholder="500" name="renditaCatastale" id="renditaCatastale" onChange={e => setRenditaCatastale(e.target.value)} />
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' for="from_name">Chi è il venditore?</label>
                    <select onChange={e => setVenditore(e.target.value)} className="select">
                        <option default value="Scegliere">Non so</option>
                        <option value="Privato">Privato</option>
                        <option value="Impresa costruttrice (entro 5 anni dalla costruzione)">Impresa costruttrice (entro 5 anni dalla costruzione)</option>
                        <option value="Società o impresa non costruttrice">Società o impresa non costruttrice</option>
                    </select>
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Agevolazioni "Prima casa"</label>
                    <select onChange={e => setAgevolazioniPrimaCasa(e.target.value)} className="select">
                    <option default value="Scegliere">Non so</option>
                        <option value='Si'>Si</option>
                        <option value='No'>No</option>
                    </select>
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Verrà richiesto un mutuo?</label>
                    <select onChange={e => setRichiestaMutuo(e.target.value)} className="select">
                        <option default value="Scegliere">Non so</option>
                        <option value='Si'>Si</option>
                        <option value='No'>No</option>
                    </select>
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <div className="field">
                    <label className='customLab' for="message">Informazioni aggiuntive</label>
                    <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                </div>
            </MDBRow>
            </>
	);
}